export default "__VITE_ASSET__CAOJihGF__"